import React from "react";
import styled from "styled-components";
import { FiBriefcase, FiFolder, FiSearch, FiZap } from "react-icons/fi";
import { useTheme } from "../../../context/ThemeContext";

const iconSize = 36;
const iconColorLight = "#063922";
const iconColorDark = "#D4AF37";

export default function ServiceBox({ icon, title, subtitle }) {
  const { theme } = useTheme();
  const iconColor = theme === "dark" ? iconColorDark : iconColorLight;
  let getIcon;

  switch (icon) {
    case "briefcase":
      getIcon = <FiBriefcase size={iconSize} color={iconColor} />;
      break;
    case "folder":
      getIcon = <FiFolder size={iconSize} color={iconColor} />;
      break;
    case "search":
      getIcon = <FiSearch size={iconSize} color={iconColor} />;
      break;
    case "workflow":
      getIcon = <FiZap size={iconSize} color={iconColor} />;
      break;
    default:
      getIcon = <FiBriefcase size={iconSize} color={iconColor} />;
      break;
  }


  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;